import axios from '../../../helpers/custom-axios';
import Papa from 'papaparse';
import dayjs from 'dayjs';
import {
  parseAndCreateOptions,
  parseAndUpdateOptions,
} from './handleOptionCSV';
import {
  confirmation,
  loadingBlock,
  notify,
} from '../../../helpers/notifications';
import { getFilenameFromHeader } from '../../../helpers/filename-from-header';
import { downloadBlob } from '../../../helpers/downloadBlob';
var utc = require('dayjs/plugin/utc');
var tz = require('dayjs/plugin/timezone');
dayjs.extend(utc);
dayjs.extend(tz);

export const handleCreateOption = async (option, showNotify = false) => {
  return axios
    .post('/manage/options', option)
    .then((res) => {
      if (showNotify) {
        notify.success('', { showOnlyTheLastOne: false });
      }
      return res;
    })
    .catch((error) => {
      if (showNotify) {
        notify.failure('', { showOnlyTheLastOne: false });
      }
      return error;
    });
};

export const handleUpdateOption = async (id, option) => {
  return axios
    .put(`manage/options/${id}`, {
      option,
    })
    .then((res) => {
      notify.success('Option Saved', { showOnlyTheLastOne: true });
      return res;
    })
    .catch((error) => {
      notify.failure('Option Failed to Save', { showOnlyTheLastOne: false });
      return error;
    });
};

export const handleDeleteOption = async (id, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/options/${id}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
};

export const handleDeleteAllOptions = async (field_id, callback) => {
  const alertCallback = () => loadingBlock.remove('.options');
  confirmation.destroy(async () => {
    loadingBlock.add('.options', 'Deleting Options...');
    return axios
      .post('/manage/options/destroy_all', { field_id })
      .then((res) => {
        notify.alertSuccess(
          'Options Deleted',
          `Deleted: ${res.data.deleted}
        <br>Failed: ${res.data.failed}`,
          alertCallback,
        );
        callback(res);
      })
      .catch((error) => {
        notify.alertFailure(
          'Delete operation failed',
          'Something went wrong...',
          alertCallback,
        );
        callback(error);
      });
  });
};

// used to pull in refreshed metadata_contents after option edited (without altering option)
export const fetchOption = async (id) => {
  return axios
    .get(`manage/options/${id}`)
    .then((res) => res)
    .catch((error) => error);
};

export const createFromCSV = (params) => {
  let input = document.getElementById('csvCreate');
  input.onchange = (e) => parseAndCreateOptions(e.target.files[0], params);
  input.click();
};

export const updateFromCSV = (params) => {
  let input = document.getElementById('csvUpdate');
  input.onchange = (e) => parseAndUpdateOptions(e.target.files[0], params);
  input.click();
};

export const exportOptionsTemplate = (params, includeIcal) => {
  const { field, options, metaEntries } = params;
  let header = ['id', 'name', 'value', 'local_quota'];
  let calProps = [
    'summary',
    'description',
    'dtstart',
    'dtend',
    'timezone',
    'location',
    'alert_trigger',
  ];
  let optionValueArray = [];

  if (metaEntries.length) {
    metaEntries.forEach((me) => {
      header.push('me_' + me.title.split(' ').join('_').toLowerCase());
    });
  }

  if (includeIcal) {
    let calHeaders = calProps.map((key) => 'ical_' + key);
    header = header.concat(calHeaders);
  }

  if (options.length) {
    options.forEach((opt) => {
      let optionData = [opt.id, opt.name, opt.value, opt.local_quota];

      metaEntries.forEach((me) => {
        let mc = opt.metadata_contents.find(
          (mc) => mc.metadata_entry_id == me.id,
        );
        optionData.push(mc ? mc.description : '');
      });

      if (includeIcal) {
        calProps.forEach((key) => {
          let value = opt?.calendar_event?.[key];
          if (opt.calendar_event && ['dtstart', 'dtend'].includes(key)) {
            value = dayjs
              .utc(value)
              .tz(opt.calendar_event.timezone)
              .format('MM/DD/YYYY hh:mm A');
          }
          optionData.push(value || '');
        });
      }

      optionValueArray.push(optionData);
    });
  } else {
    // push an empty row, generating a template row for convenience
    optionValueArray.push(header.map(() => ''));
  }

  let csv = Papa.unparse({
    fields: header,
    data: optionValueArray,
  });

  let blob = new Blob([csv], { type: 'text/csv' });
  let filename = field.name.split(' ').join('_') + '_template.csv';
  downloadBlob(blob, filename);
};

export const exportOptionCounts = (params) => {
  const { field, options } = params;
  if (options.length) {
    let header = ['ID', 'Name', 'Value', 'Response Count', 'Quota'];
    let optionValueArray = [];

    options.forEach((opt) => {
      let optionData = [
        opt.id,
        opt.name,
        opt.value,
        opt.response_options_count,
        opt.local_quota,
      ];

      optionValueArray.push(optionData);
    });

    let csv = Papa.unparse({
      fields: header,
      data: optionValueArray,
    });

    let blob = new Blob([csv], { type: 'text/csv' });
    let filename = field.name.split(' ').join('_') + '_option_details.csv';
    downloadBlob(blob, filename);
  }
};

export const exportFilteredCounts = async (path) => {
  return await axios
    .get(path)
    .then((res) => {
      if (res.ok) {
        let blob = new Blob([res.data], { type: 'text/csv' });
        let filename =
          getFilenameFromHeader(res.headers['content-disposition']) ||
          'FilteredCountExport.csv';
        downloadBlob(blob, filename);
      }
      return res.ok;
    })
    .catch((err) => notify.failure());
};
